<template>
  <div :class="['wrapper', classes]">
    <header class="main-header">
  <!-- <span class="logo-mini">
    <img src="/static/img/logo_white_bg.png" class="navbar-brand" width="230px" style=" background-color: white">
  </span> -->
      <a href="/" class="logo" style="padding-left:0px;padding-right:0px">
       <span class="logo-lg" > 
        <img src="/static/img/logo_white_bg.png" alt="Logo" class="img-responsive logo" width="230px" style="background-color:white">
       </span>
       <span class="logo-mini" style="background-color:#f2f2f2"></span>
      </a>
      <!-- Header Navbar -->
      <nav class="navbar navbar-static-top" role="navigation">
        <!-- Sidebar toggle button-->
        <a href="javascript:;" class="sidebar-toggle" data-toggle="offcanvas" role="button">
          <span class="sr-only">Toggle navigation</span>
        </a>
        <span class="navmenu">
           Merchant Portal - <small> {{$route.name.toUpperCase() }} </small>
        </span>

        <!-- Navbar Right Menu -->
        <div class="navbar-custom-menu">

          <ul class="nav navbar-nav">
            
            <li class="dropdown user user-menu">
                <a href="#" class="dropdown-toggle" data-toggle="dropdown">
                  <span class="hidden-xs">{{ this.user.firstName + " " + this.user.lastName}} <span class="caret"></span> </span>
                </a>
                <ul class="dropdown-menu">
                  <!-- User image -->
                  <li class="user-header">
                    <v-icon x-large color="white">account_circle</v-icon>
                    <p>
                      {{ this.user.firstName + " " + this.user.lastName}}
                      <small>{{ this.user.role }}</small>
                    </p>
                  </li>
                  <!-- Menu Footer-->
                  <li class="user-footer">
                    <div class="pull-left">
                      <router-link tag="li" class="pageLink" to="/user/updatepassword"> <v-btn small> Profile </v-btn> </router-link>
                    </div>
                    <div class="pull-right">
                      <v-btn small @click="logout"> Log Out </v-btn>
                    </div>
                  </li>
                </ul>
              </li>
          </ul>
        </div>
      </nav>
    </header>
    <!-- Left side column. contains the logo and sidebar -->
    <sidebar :display-name="demo.displayName" :picture-url="demo.avatar" />

    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper" >

      <router-view></router-view>
    </div>
    <!-- /.content-wrapper -->

    <!-- Main Footer -->
    <footer class="main-footer">
      <strong>Copyright &copy; {{year}}
        <a href="javascript:;">Co-operative Bank</a>.</strong> All rights reserved.
    </footer>
  </div>
  <!-- ./wrapper -->
</template>

<script>
import { mapState } from 'vuex'
import config from '../config'
import Sidebar from './Sidebar'
import axios from 'axios'

export default {
  name: 'Dash',
  components: {
    Sidebar
  },
  data: function () {
    return {
      // section: 'Dash',
      year: new Date().getFullYear(),
      classes: {
        fixed_layout: config.fixedLayout,
        hide_logo: config.hideLogoOnMobile
      },
      error: ''
    }
  },
  computed: {
    ...mapState([
      'userInfo', 'user'
    ]),
    demo () {
      return {
        displayName: ''
      }
    }
  },
  methods: {
    changeloading () {
      this.$store.commit('TOGGLE_SEARCHING')
    },
    logout () {
      var url = config.serverURI + '/token/logout'
      console.log(this.user)
      axios.post(url, this.user, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
          .then(response => {
            console.log('Update Response:', response)
            this.message = response.data.message
          })
          .catch(error => {
            // Request failed.
            console.log('error', error.response)
            var data = error.response.data
            console.log(data.message)
            if (data.message === 'Unauthorized') {
              console.log('redirecting')
              window.location = '/login'
            } else {
              this.error = data.message
            }
          })
      this.$store.commit('SET_USER', null)
      this.$store.commit('SET_TOKEN', null)
      if (window.localStorage) {
        window.localStorage.setItem('user', null)
        window.localStorage.setItem('token', null)
      }
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss">
.wrapper.fixed_layout {
  .main-header {
    position: fixed;
    width: 100%;
  }

  .content-wrapper {
    padding-top: 50px;
  }

  .main-sidebar {
    position: fixed;
    height: 100vh;
  }
}

.wrapper.hide_logo {
  @media (max-width: 767px) {
    .main-header .logo {
      display: none;
    }
  }
}

.logo-mini,
.logo-lg {
  text-align: left;

  img {
    padding: .4em !important;
  }
}

.logo-lg {
  img {
    display: -webkit-inline-box;
    width: 25%;
  }
}

.user-panel {
  height: 4em;
}

hr.visible-xs-block {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.17);
  height: 1px;
  border-color: transparent;
}

.navmenu{
  float:left;
  background-color:transparent;
  background-image:none;
  padding:15px 5px;
  background:transparent;
  color:#fff;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// Dash.vue?17e6ec46